import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { type ReactNode } from 'react';

import { Text } from 'common';

export enum FlowTemplateFilterGroupState {
  Collapsed = 'Collapsed',
  Expanded = 'Expanded',
}

interface FlowTemplateFilterGroupProps {
  label: string;
  children: ReactNode;
  state: FlowTemplateFilterGroupState;
  onStateChange: (state: FlowTemplateFilterGroupState) => void;
}
export function FlowTemplateFilterGroup(props: FlowTemplateFilterGroupProps) {
  const { label, children, state, onStateChange } = props;
  return (
    <Accordion
      expanded={state === FlowTemplateFilterGroupState.Expanded}
      onChange={(_event, isExpanded) => {
        onStateChange?.(
          isExpanded
            ? FlowTemplateFilterGroupState.Expanded
            : FlowTemplateFilterGroupState.Collapsed
        );
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Text variant="heading4">{label}</Text>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
